export const SLICE_CONTAINER = "container mx-auto ";
export const VERSION_2 = "v2";
export const VERSION_3 = "v3";
export const DEFAULT = "default";
export const HOW_IT_WORKS = "how-it-works";
